import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

/** Owner, 2026-10-03: callers see emails and phone numbers only on the companies of their
 *  live call session — and, since 2026-10-07, on the ones they have called there, so a
 *  call-back from a task shows the number. The backend sends `null` and names the field in
 *  `hidden_details`; this is what stands in its place, so "hidden" never reads as "none". */
export const HIDDEN_DETAIL_HINT =
  "Shown only on the companies of your call session and the ones you have called";

export function isHidden(
  item: { hidden_details?: string[] } | null | undefined,
  field: string,
): boolean {
  return !!item?.hidden_details?.includes(field);
}

export function HiddenDetail({
  label,
  className,
}: {
  label: "Email" | "Phone";
  className?: string;
}) {
  return (
    <span
      title={HIDDEN_DETAIL_HINT}
      className={cn("inline-flex items-center gap-1 text-slate-400", className)}
    >
      <Lock className="h-3 w-3" aria-hidden />
      {label} hidden
    </span>
  );
}
